import React, { Component } from 'react';
import '../../../App.css';
import '../../../styles/app-demo.css';
import Moment from 'react-moment';

class ConfirmPayment extends Component {

  constructor(props){
    super(props)
    this.handlePaymentConfirmation = this.handlePaymentConfirmation.bind(this);
    }

  handlePaymentConfirmation() {
    this.props.updateBillPayList({
      name: 'Sheffield Financial LLC',
      amount: this.props.amount,
      date: this.props.date
    })
    this.props.handleBillPayRoute('home')
  }

  render() {

    return (
      <div className="fintwist-interactive-mobile">
        <section className="mobile-app-wrapper">
          <div className="orange-header">
            <i onClick={() => this.props.handleBillPayRoute('bill pay date')} className="fa fa-angle-left"></i>
            <h2>Confirm Payment</h2>
          </div>
          <div className="mobile-app-dashboard">
            <div id="confirm-payment-top-wrapper">
              <ul className="app-list">
                <li className="confirm-payment-list-item">
                  <div className="app-list-pre-row">
                    <p>From Account</p>
                  </div>
                  <div className="app-list-row-1">
                    <p><span>Fintwist Account</span></p>
                  </div>
                </li>
                <li className="confirm-payment-list-item">
                  <div className="app-list-pre-row">
                    <p>To Account</p>
                  </div>
                  <div className="app-list-row-1">
                    <p><span>Sheffield Financial LLC</span></p>
                  </div>
                </li>
                <li className="confirm-payment-list-item">
                  <div className="app-list-pre-row">
                    <p>Frequency</p>
                  </div>
                  <div className="app-list-row-1">
                    <p><span>{this.props.frequency}</span></p>
                  </div>
                </li>
                <li className="confirm-payment-list-item">
                  <div className="app-list-pre-row">
                    <p>Send On</p>
                  </div>
                  <div className="app-list-row-1">
                    <span><Moment format="MM/DD/YYYY">{this.props.date}</Moment></span>
                  </div>
                </li>
                <li className="confirm-payment-list-item">
                  <div className="app-list-pre-row">
                    <p>End Date</p>
                  </div>
                  <div className="app-list-row-1">
                    <span><Moment add={{ days: 1}} format="MM/DD/YYYY">{this.props.date}</Moment></span>
                  </div>
                </li>
              </ul>
            </div>
            <ul id="payment-description-list">
              <li className="confirm-payment-list-item">
                <div className="app-list-pre-row">
                  <p>Description (Optional)</p>
                  <input placeholder={'Enter Here'} />
                </div>
              </li>
              </ul>
            <button onClick={this.handlePaymentConfirmation} className="bill-pay-button">CONTINUE</button>
          </div>
        </section>
      </div>
    );
  }
}

export default ConfirmPayment;
